import React, { useEffect } from 'react'
import PatientAppointment from '../../components/Appointments/PatientAppointment'
const PatientBookAppointment = () => {
    useEffect(() => {
        // Load Google Translate script dynamically
        const addScript = document.createElement('script')
        addScript.src =
            'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
        document.body.appendChild(addScript)

        // Define init function globally for Google Translate callback
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'en',
                    autoDisplay: false,
                },
                'google_translate_element',
            )
        }

        return () => {
            // cleanup
            delete window.googleTranslateElementInit
        }
    }, [])
    return <PatientAppointment />
}

export default PatientBookAppointment
